
export default function EmergencyHero() {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/72ea295f74781d185021dbda0836b8e4.jpg"
          alt="Roseville Emergency Resources"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto w-full pt-24">
        <div className="inline-flex items-center space-x-2 bg-red-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-red-400/30">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
          </span>
          <span className="text-white text-sm font-medium">Emergency Resources &amp; Safety</span>
        </div>

        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Emergency Contacts &amp;<br />
          <span className="text-teal-400">Safety Information</span>
        </h1>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto font-light">
          Essential phone numbers, safety tips, and preparedness resources for Roseville residents and visitors
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="tel:911"
            className="bg-red-600 hover:bg-red-700 text-white px-8 py-3.5 rounded-full font-semibold transition-all shadow-lg shadow-red-600/30 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-phone-fill"></i>
            Call 911
          </a>
          <a
            href="#contacts"
            onClick={(e) => { e.preventDefault(); document.getElementById('contacts')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="bg-white/20 hover:bg-white/30 text-white px-8 py-3.5 rounded-full font-semibold transition-colors backdrop-blur-sm whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-contacts-book-line"></i>
            All Contacts
          </a>
          <a
            href="#safety-tips"
            onClick={(e) => { e.preventDefault(); document.getElementById('safety-tips')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="bg-white/20 hover:bg-white/30 text-white px-8 py-3.5 rounded-full font-semibold transition-colors backdrop-blur-sm whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-shield-check-line"></i>
            Safety Tips
          </a>
        </div>
      </div>
    </section>
  );
}
